<template>
  <div>
    <!-- <equipment-modal v-if="isNewEquipmentModalOpened" @close="isNewEquipmentModalOpened = false" @submitted="equipmentCreated" /> -->
    <equipment-modal
      @close="closeEquipmentModal"
      @created="equipmentCreated"
      @updated="equipmentUpdated"
      @removed="equipmentRemoved"
      v-if="isEquipmentModalOpened"
    />
    <!-- <equipment :key="equipmentId" :id="equipmentId" v-if="isEquipmentOpened" /> -->
    <v-row no-gutters justify="center" align="start">
      <div class="n-container">
        <v-row no-gutters justify="start" align="start">
          <v-expand-x-transition>
            <div v-show="areFiltersOpened">
              <div class="side-content-medium ml-6">
                <v-row no-gutters align="center" class="content-header">
                  <v-icon small class="mr-2 pb-1">filter_list</v-icon>
                  <div class="font-weight-bold">Filtres</div>
                  <v-spacer></v-spacer>
                  <v-btn icon @click="areFiltersOpened = false">
                    <v-icon small>clear</v-icon>
                  </v-btn>
                </v-row>
                <n-card class="pt-2 pb-6">
                  <div class="filter-item-title mt-4 px-4">
                    Recherche
                  </div>
                  <div class="filter-item-content-list px-4">
                    <v-text-field
                      v-model="label"
                      single-line
                      solo
                      placeholder="Désign., num de série, etc..."
                      hide-details
                      clearable
                      flat
                      outlined
                      height="36px"
                      style="width: 100%;"
                      class="n-text-field"
                      @input="labelChanged"
                    />
                  </div>
                  <template v-if="isAggregator && false">
                    <div class="filter-item-title mt-4 px-4">
                      Prestataire
                    </div>
                    <div class="filter-item-content-list px-4">
                      <v-autocomplete
                        :items="makers"
                        v-model="maker"
                        single-line
                        solo
                        placeholder="Tous"
                        hide-details
                        item-text="name"
                        item-value="id"
                        clearable
                        flat
                        style="width: 100%;"
                        class="n-select mr-4"
                      ></v-autocomplete>
                    </div>
                  </template>
                  <template v-else-if="isMakerUser">
                    <div class="filter-item-title mt-4 px-4">
                      Client
                    </div>
                    <div class="filter-item-content-list px-4">
                      <v-autocomplete
                        :items="clients"
                        v-model="client"
                        single-line
                        solo
                        placeholder="Tous"
                        hide-details
                        item-text="name"
                        item-value="id"
                        clearable
                        flat
                        style="width: 100%;"
                        class="n-select mr-4"
                      ></v-autocomplete>
                    </div>
                  </template>
                  <template v-if="hasClientSelected">
                    <div class="filter-item-title mt-4 px-4">
                      Site
                    </div>
                    <div class="filter-item-content-list px-4">
                      <v-autocomplete
                        :items="sites"
                        v-model="site"
                        single-line
                        solo
                        placeholder="Tous"
                        hide-details
                        item-text="$label"
                        item-value="id"
                        clearable
                        flat
                        height="36px"
                        style="width: 100%;"
                        class="n-select mr-4"
                      ></v-autocomplete>
                    </div>
                  </template>
                </n-card>
              </div>
            </div>
          </v-expand-x-transition>
          <v-col align="center" class="pa-0 mx-6">
            <v-row no-gutters align="center" class="content-header">
              <v-expand-x-transition>
                <div v-show="!areFiltersOpened">
                  <v-btn class="n-white-btn n-small-btn px-2 mr-2" @click="areFiltersOpened = true">
                    <v-icon small class="mr-2">filter_list</v-icon>
                    Filtrer
                  </v-btn>
                </div>
              </v-expand-x-transition>
              <span class="font-weight-bold">Équipements</span>
              <v-spacer></v-spacer>
              <pager @change="fetchEquipments()" />
              <v-btn class="n-white-btn n-small-btn n-icon-btn ml-2" @click="forceFetchEquipments">
                <v-icon>refresh</v-icon>
              </v-btn>
              <v-btn color="primary darken-1" class="n-primary-btn n-small-btn px-3 ml-3" @click="isEquipmentModalOpened = true" v-if="canAddEquipment">
                <v-icon small class="mr-2">add</v-icon>
                Nouvel équipement
              </v-btn>
            </v-row>
            <v-row no-gutters justify="center" align="center" v-if="isFetchingList">
              <div style="margin-top: 20%; width: 250px;">
                <v-progress-linear
                  color="primary"
                  indeterminate
                  rounded
                  height="6"
                ></v-progress-linear>
              </div>
            </v-row>
            <div class="page-main-content" v-else>
              <template v-if="equipments.length > 0">
                <template v-for="(equipment, i) in equipments">
                  <div :key="i" class="mb-3" @click="openEquipment(equipment)">
                    <equipment-card :value="equipment" clickable></equipment-card>
                  </div>
                </template>
                <pager @change="fetchEquipments()" class="mt-6" />
              </template>
              <v-row no-gutters justify="center" align="center" v-else>
                <div style="margin-top: 20%; font-weight: 500;">
                  Aucun équipement à afficher
                </div>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import EquipmentCard from '@/components/Equipments/Card.vue';
// import Equipment from '@/components/Equipments/Equipment.vue';
import EquipmentModal from '@/components/Equipments/EquipmentModal.vue';
import Pager from '@/components/Equipments/Pager.vue';

export default {
  name: `Equipments`,
  data: () => ({
    areFiltersOpened: true,
    labelTimeout: null,
    equipmentId: null,
    isListHasBeenFetchedOnce: false,
    isFetchingList: false,
    // equipmentInModal: null,
    isEquipmentModalOpened: false,
    isSubmittingEquipment: false,
  }),
  computed: {
    ...mapState(`model/maker`, [`makers`]),
    ...mapState(`model/client`, [
      `company`,
      `isAggregator`,
      `isSelfMaker`,
    ]),
    ...mapState(`model/user`, [`me`, `isMakerUser`, `isAggregatorUser`]),
    ...mapState(`ui/equipments`, [`clients`]),
    ...mapState(`ui/equipments`, {
      sites: state => state.sites.map(site => {
        const $refLabel = site.ref && site.ref.length ? ` (Ref: ${site.ref})` : ``;
        return {
          ...site,
          $label: `${site.name}${$refLabel}`,
        };
      }),
    }),
    ...mapState(`ui/equipments`, {
      equipments: `list`,
    }),
    label: {
      get() { return this.$store.state[`ui/equipments`].label || ``; },
      set(label) { this.$store.commit(`ui/equipments/SET_LABEL`, label || ``); },
    },
    maker: {
      get() { return this.$store.state[`ui/equipments`].maker; },
      set(maker) { this.$store.commit(`ui/equipments/SET_MAKER`, maker); },
    },
    client: {
      get() { return this.$store.state[`ui/equipments`].client; },
      set(client) { this.$store.commit(`ui/equipments/SET_CLIENT`, client); },
    },
    site: {
      get() { return this.$store.state[`ui/equipments`].site; },
      set(site) { this.$store.commit(`ui/equipments/SET_SITE`, site); },
    },
    hasClientSelected() {
      return Boolean(this.client);
    },
    canAddEquipment() { return Boolean((this.me.client.isRoot || this.isSelfMaker || this.isAggregator) && this.me.role === `administrator`); },
    equipmentInModal: {
      get() { return this.$store.state[`ui/equipmentModal`].equipment; },
      set(equipment) { this.$store.commit(`ui/equipmentModal/SET_EQUIPMENT`, equipment); },
    },
    isEquipmentOpened() {
      return this.equipmentId !== null;
    },
  },
  methods: {
    ...mapActions(`ui/equipments`, [
      `updateEquipmentLocally`,
      `removeEquipmentLocally`,
    ]),
    openEquipment(equipment) {
      this.equipmentInModal = equipment;
      this.isEquipmentModalOpened = true;
    },
    // goToEquipment(id) {
    //   if (this.equipmentId && this.equipmentId === id) {
    //     return;
    //   }

    //   this.$router.push({
    //     name: `EquipmentsEquipment`,
    //     params: {
    //       equipmentId: id,
    //     },
    //   });
    // },
    fetchSites() {
      this.$store.dispatch(`ui/equipments/fetchSites`, this.client);
    },
    async forceFetchEquipments() {
      this.isFetchingList = true;
      await this.$store.dispatch(`ui/equipments/forceFetchList`);
      this.isFetchingList = false;
      this.isListHasBeenFetchedOnce = true;
    },
    async fetchEquipments(isInitPager = false) {
      if (this.isFetchingList) { return; }
      this.isFetchingList = true;
      if (isInitPager) {
        this.$store.commit(`ui/equipments/SET_PAGE`, 1);
      }
      await this.$store.dispatch(`ui/equipments/fetchList`);
      this.isFetchingList = false;
      this.isListHasBeenFetchedOnce = true;
    },
    setEquipmentIdFromRoute() {
      const params = this.$route.params || {};
      this.equipmentId = params.equipmentId || null;
    },
    async fetchUiDatas() {
      const promises = [
        this.fetchEquipments(),
      ];
      if (this.isMakerUser) {
        promises.push(this.$store.dispatch(`ui/equipments/fetchClients`));
      } else {
        promises.push(this.$store.dispatch(`ui/equipments/fetchSites`));
      }
      if (this.isAggregatorUser) {
        promises.push(this.$store.dispatch(`model/maker/fetchMakers`));
      }
      await Promise.all(promises);
    },
    labelChanged() {
      clearTimeout(this.labelTimeout);
      this.labelTimeout = setTimeout(() => {
        this.fetchEquipments();
      }, 200);
    },
    closeEquipmentModal() {
      this.isEquipmentModalOpened = false;
      this.equipmentInModal = null;
    },
    equipmentCreated() {
      this.forceFetchEquipments();
    },
    equipmentUpdated(equipment) {
      this.updateEquipmentLocally(equipment);
    },
    equipmentRemoved(equipment) {
      this.removeEquipmentLocally(equipment);
      this.equipmentInModal = null;
      this.isEquipmentModalOpened = false;
    },
  },
  beforeMount() {
    if (!this.isMakerUser && !this.isAggregatorUser) {
      this.$store.commit(`ui/equipments/SET_CLIENT`, this.me.client.id);
    }
    this.setEquipmentIdFromRoute();
    if (!this.equipmentId) {
      this.fetchUiDatas();
    }
  },
  components: {
    EquipmentCard,
    // Equipment,
    EquipmentModal,
    Pager,
  },
  watch: {
    '$route.path': function watchRoutePath() {
      this.setEquipmentIdFromRoute();
    },
    equipmentId(equipmentId) {
      if (!equipmentId) {
        this.fetchUiDatas();
      }
    },
    maker() { this.fetchEquipments(true); },
    client() {
      if (this.hasClientSelected) {
        this.fetchSites();
      } else {
        this.site = null;
      }
      this.fetchEquipments(true);
    },
    site() { this.fetchEquipments(true); },
  },
};
</script>

<style lang="scss">

.filter-item-title {
  font-weight: 500;
}

.filter-item-content-list {
  padding-top: 6px;
  & > a {
    padding: 6px 4px;
    display: block;
    color: #333 !important;
    font-size: 0.9rem;
    &:hover {
      background-color: #EEE;
    }
    &.selected {
      background-color: #2226ca;
      font-weight: 500;
      color: #FFF !important;
    }
  }
}

</style>
